// extracted by mini-css-extract-plugin
module.exports = {"prizes_list":"style_prizes_list__3uwGv","leaderboard_title":"style_leaderboard_title__-XFJm","champion":"style_champion__1NGlb"};